export default __webpack_public_path__ + "static/media/DonationRed.3c9f95d5.png";